
import { useWebSiteStore } from '@/stores/web-site.store'

export const useClaimService = () => {
  const webSiteStore = useWebSiteStore()

  const decode = (permissions) => {
    // Remove the b'' prefix and suffix, if present
    const normalizedClaim = permissions.replace(/^b'|^b"|\'$/g, '')
    // Decode the Base64 string to a byte array
    const binaryString = atob(normalizedClaim)
    const byteArray = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i)
    }
    // Convert the byte array to an integer (big-endian)
    let intValue = 0n
    for (const byte of byteArray) {
      intValue = (intValue << 8n) | BigInt(byte)
    }
    return intValue
  }

  const hasClaim = (claim) => {
    if (typeof claim === 'function') {
      return claim()
    }
    const claimCode = webSiteStore.claimsMap[claim]
    return !!(claimCode && (webSiteStore.decodedPermissions & (1n << BigInt(claimCode))) !== 0n)
  }

  return {
    decode,
    hasClaim,
  }
}
